import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../config/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Inicializar MSAL
export const initializeMsal = async () => {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
};

// Login con popup
export const login = async () => {
    try {
        const loginResponse = await msalInstance.loginPopup(loginRequest);
        return loginResponse;
    } catch (error) {
        console.error("Error en login:", error);
        throw error;
    }
};

// Logout
export const logout = () => {
    const currentAccount = msalInstance.getAllAccounts()[0];
    msalInstance.logoutPopup({
        account: currentAccount
    });
};

// Obtener access token
export const getAccessToken = async () => {
    const accounts = msalInstance.getAllAccounts();
    
    if (accounts.length === 0) {
        throw new Error("No hay sesión activa");
    }

    const request = {
        ...loginRequest,
        account: accounts[0]
    };

    try {
        // Intentar obtener token silenciosamente
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        console.log("Token silencioso falló, intentando con popup:", error);
        // Si falla, mostrar popup
        try {
            const response = await msalInstance.acquireTokenPopup(request);
            return response.accessToken;
        } catch (popupError) {
            console.error("Error obteniendo token:", popupError);
            throw popupError;
        }
    }
};

// Obtener usuario actual
export const getCurrentUser = () => {
    const accounts = msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
};

// Verificar si hay sesión activa
export const isAuthenticated = () => {
    return msalInstance.getAllAccounts().length > 0;
};
